"use client";

import { c as _c } from "react/compiler-runtime";
import { useAtomValue } from "jotai";
import * as m from "motion/react-m";
import { useIsMobile } from "@/hooks/use-mobile";
import { useScrollDirection } from "@/hooks/use-scroll-direction";
import { isSearchFocusedAtom } from "@/lib/atoms/search-atoms";
import { cn } from "@domainstack/ui/utils";
export function AppHeaderGrid(t0) {
  const $ = _c(15);
  const {
    children
  } = t0;
  const isSearchFocused = useAtomValue(isSearchFocusedAtom);
  const isMobile = useIsMobile();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      threshold: 15
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    direction,
    isPastThreshold
  } = useScrollDirection(t1);
  const shouldHideHeader = isMobile && isPastThreshold && direction === "down";
  const t2 = isMobile && (isPastThreshold ? shouldHideHeader ? "fixed -translate-y-full" : "fixed translate-y-0 transition-transform duration-300 ease-out" : "absolute translate-y-0");
  let t3;
  if ($[1] !== t2) {
    t3 = cn("top-0 right-0 left-0 z-100 grid h-[var(--header-height)] grid-cols-[1fr_minmax(0,var(--container-2xl))_1fr] items-center gap-4 border-b border-black/15 bg-background/80 py-3 pr-4 pl-6 backdrop-blur dark:border-white/10", "md:sticky md:right-auto md:left-auto", t2);
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = isMobile ? isSearchFocused ? "auto 1fr 0px" : "auto 1fr auto" : "";
  let t5;
  if ($[3] !== t4) {
    t5 = {
      gridTemplateColumns: t4
    };
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      gridTemplateColumns: {
        type: "spring",
        stiffness: 400,
        damping: 40
      }
    };
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== children || $[7] !== t3 || $[8] !== t5) {
    t7 = <m.header className={t3} animate={t5} transition={t6} initial={false}>{children}</m.header>;
    $[6] = children;
    $[7] = t3;
    $[8] = t5;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== isMobile) {
    t8 = isMobile && <div className="h-[var(--header-height)]" aria-hidden={true} />;
    $[10] = isMobile;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t7 || $[13] !== t8) {
    t9 = <>{t7}{t8}</>;
    $[12] = t7;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  return t9;
}